import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

// actions
import { HrActionTypes, HrActions } from "../../../actionTypes/hr/hrActionTypes";
import { setMyLeaveList, setMyLeaveListCount } from "../../../actions/hr/hrActions";
// request
import { getMyLeaveListApi } from "../../requests/hr/hrRequests";


function* getMyLeaveListHandler(action: HrActionTypes) {
  if(action.payload.search){
    yield delay(500); //to hit search api after 500ms of the last key stroke
  }
  try {
    yield startLoader("transparent");
    const { data } = yield call(getMyLeaveListApi, action.payload);
    if (data.status) {
      const fallbackData = [
        {
          id: 0,
          status: "-",
          employee_id: 0,
          remarks: null,
          reason: "-",
          created_by: 0,
        },
      ];
      yield put(setMyLeaveList(data?.data?.rows || fallbackData));
      yield put(setMyLeaveListCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// function* getLeaveByIdHandler(action: HrActionTypes) {
//   try {
//     yield startLoader("transparent");
//     const { data } = yield call(getLeaveDataByIdApi, action.payload);
//     if (data.status) {
//       yield put(setLeaveData(data?.data));
//     } else {
//       toast.error(data?.message, {
//         position: "top-right",
//       });
//     }
//   } catch (error: any) {
//     toast.error(error?.response?.data?.message, {
//       position: "top-right",
//     });
//   } finally {
//     yield stopLoader("transparent");
//   }
// }

// function* editLeaveHandler(action: HrActionTypes) {
//   try {
//     yield startLoader("transparent");
//     const { data } = yield call(editLeaveApi, action.payload);
//     if (data.status) {
//       toast.success(data.message, {
//         position: "top-right",
//       });
//       yield put(setPutApiStatus(true));
//       // yield put(getBranchList({ page: 0, pageLimit: 10 }));
//     }
//   } catch (error: any) {
//     toast.error(error?.response?.data?.message, {
//       position: "top-right",
//     });
//     yield put(setPutApiStatus(false));
//   } finally {
//     yield stopLoader("transparent");
//   }
// }

export default function* myLeaveSaga() {
  yield takeLatest(HrActions.GET_MY_LEAVE_LIST, getMyLeaveListHandler);
}